export const ACTIVE_FISCAL_YEAR_ID_HEADER = 'ACTIVE-FISCAL-YEAR-ID';
